import { Result, theme } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { TextService } from "../../Services/TextService";
import { EventType } from "../../Types/EventType";

/**
 * Shown to a guest when an event can no longer be answered: closed by the admin or past its deadline.
 * A calm message with the event's name, since nothing has gone wrong.
 */
const EventClosedPage = (props: { event: any, deadlinePassed: boolean }) => {
    const GetText = TextService.GetText;
    const { token } = theme.useToken();
    const title = props.deadlinePassed ? "EventClosed_DeadlineTitle" : props.event?.eventType === EventType.Poll ? "EventClosed_PollTitle" : "EventClosed_SignUpTitle";

    return <Result
        icon={<CalendarOutlined style={{ color: token.colorPrimary }} />}
        title={GetText(title)}
        subTitle={<>
            {props.event?.name ? <div>{GetText("EventClosed_Text")} <b>{props.event.name}</b>.</div> : null}
            <div>{GetText("EventClosed_Contact")}</div>
        </>}
    />
};

export default EventClosedPage;
